<template>
	<b-modal v-model="isShowPopup" dialog-class="modal-detail" @hidden="resetModal" scrollable :no-close-on-backdrop=true @ok="addButtonAction" title="Add Data Finish  Good Quality Inspection Ng">
		<b-card>
			<b-row>
				<b-col cols="12" lg="6">
				<app-input-combobox-autocomplete :options="problemCategorys" optionsLabel="name" optionsKey="id" label-cols-lg="12" label="Problem Category" id="input-" size="sm" :model.sync="model.problemCategoryId" :isRequired="true" :state="validateState('problemCategoryId')" :errorMessage="getErrorMessage(errorMessage.problemCategoryId, 'problemCategoryId')"   :selected="model.problemCategory != null ? model.problemCategory.code : ''" @input="getProblemCategorys" />
					</b-col>
					<b-col cols="12" lg="6">
				<app-input-textbox id="fieldset-qty-ng" label-cols-lg="12" label="Qty Ng" label-for="input-qty-ng" size="sm" :model.sync="model.qtyNg"  />
					</b-col>
					<b-col cols="12" lg="6">

				</b-col>
			</b-row>
		</b-card>
		<b-overlay :show="isBusy" no-wrap></b-overlay>
		<template #modal-footer="{ ok, cancel }">
      		<slot name="modal-left-button"></slot>
			<b-button size="sm" class="btn-outline-danger float-right" @click="cancel()">
				Close
			</b-button>
      		<b-overlay
					:show="isBusy"
					rounded
					opacity="0.6"
					spinner-small
					spinner-variant="primary"
					class="float-right "
					>
      			<b-button size="sm" class="float-right btn-fill-success" @click="ok()">
				Save
			</b-button>
      		</b-overlay>
		</template>
	</b-modal>
</template>
<style lang="scss" scoped>
	::v-deep .modal-dialog {
		width: 70% !important; 
	}

	@media (max-width: 576px) {
		::v-deep .modal-dialog {
			width: calc(100%) !important;
		}
	}
</style>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import FinishGoodQualityInspectionNg from '@/models/FinishGoodQualityInspection/FinishGoodQualityInspectionNg';
import FinishGoodQualityInspectionNgFilter from '@/filters/FinishGoodQualityInspection/FinishGoodQualityInspectionNgFilter';

import FinishGoodQualityInspection from '@/models/FinishGoodQualityInspection/FinishGoodQualityInspection';
import FinishGoodQualityInspectionFilter from '@/filters/FinishGoodQualityInspection/FinishGoodQualityInspectionFilter';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import ProblemCategory from '@/models/ProblemCategory/ProblemCategory';
import ProblemCategoryFilter from '@/filters/ProblemCategory/ProblemCategoryFilter';
import AppInputTextbox from '@/components/AppInputTextbox';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	props: ['modelId', 'openPopup','addButtonMethod', 'resetMethod'],
	components : {
		AppInputComboboxAutocomplete,
		AppInputTextbox,
		PopupRouterView,
	},
	mixins : [validationMixin],
	validations: {
		model: {
		problemCategoryId: {required},
		}
	},
	data() {
		return {
			model : {},
			errorMessage : {
				problemCategoryId: { required : "Problem Category is Required."},
			},
			problemCategorys : [],
			isBusy: false,
		}
	},
	methods : {
		getFinishGoodQualityInspectionNg : async function(id) {
			this.isBusy = true;
			FinishGoodQualityInspectionNg.getData(this, id).then(result => {
				this.model = result;
				this.isBusy = false;
			}).catch(error => { this.isBusy = false; });
		},
		getProblemCategorys : async function(input) {
			let filter = new ProblemCategoryFilter();
			if (input != undefined) {
				filter.code = input;
			}
			ProblemCategory.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.problemCategorys = result.data
				}
			})
			.catch(error => {});
		},

		validateState(name) {
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		addButtonAction(modalEvent) {
			modalEvent.preventDefault();

			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				let model = this.model;
				let promises = Array();
				let _this = this;
					

					
				Promise.all(promises).then((results) => {
					_this.$emit("addButtonMethod", modalEvent, _this.model); 
				});

				this.$nextTick(() => { this.$v.$reset() })
			}
		},
		resetModal() {
			this.$emit('resetMethod');
			this.$v.$reset();
		},

	},	beforeMount() {
		//this.getProblemCategorys();
	},
	async mounted(){
	},
	watch : {
		modelId(newValue) {
			if (newValue != null && newValue != undefined && newValue != '') {
				this.getFinishGoodQualityInspectionNg(newValue);
			} else {
				this.model = {};
			}
		},
		openPopup(newValue) {
			if (newValue) {
				this.getProblemCategorys();
				if (this.modelId != null && this.modelId != undefined && this.modelId != '') {
					this.getFinishGoodQualityInspectionNg(this.modelId);
				}
			} else {
				this.model = {};
			}
		}
	},
	computed: {
		isShowPopup : {
			get: function () {
				if (this.openPopup) return true;
				else return false;
			},
			set: function (newValue) {}
		},
	}
}
</script>
